import { render, staticRenderFns } from "./ServerBuilder.vue?vue&type=template&id=71274f55"
import script from "./ServerBuilder.vue?vue&type=script&lang=js"
export * from "./ServerBuilder.vue?vue&type=script&lang=js"
import style0 from "./ServerBuilder.vue?vue&type=style&index=0&id=71274f55&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports